<div>
  <div>
    <div class="header">
      <img
        [src]="currentCustomer?.logoUrlBase + 'login-logo.svg'"
        [alt]="'logo-' + currentCustomer?.domain"
      />
      <span *ngIf="currentCustomer?.domain === securityDomain">{{ currentCustomer?.name }}</span>
    </div>
    <div *ngIf="isActivated">
      <app-info-shadow-box
        [icon]="'success-icon'"
        [title]="'Activated account'"
        [text]="'Activated account now'"
        [hasButton]="true"
      ></app-info-shadow-box>
    </div>
    <div *ngIf="!validToken && !isActivated">
      <app-info-shadow-box
        [icon]="'alert-icon'"
        [title]="'Invalid token'"
        [text]="'Check the token activate'"
        [hasButton]="true"
      ></app-info-shadow-box>
    </div>
  </div>
</div>
